import type { UserSessionsByType } from "../api/user-sessions";

export const MOCK_LEGACY_USER_SESSIONS: UserSessionsByType = {
	FORMATIVE: [
		{
			id: 7308904,
			collectionId: 673,
			numericId: 7308904,
			status: "COMPLETE",
			startTime: "2026-01-23 14:34:58.565+00",
			sessionType: "FORMATIVE",
			sessionSubType: null,
			distribution: {
				high: 4,
				low: 1,
				medium: 0,
				none: 0,
			},
			numItems: 5,
			numCorrect: 4,
			numIncorrect: 1,
			numSkipped: 0,
			timeTaken: 164,
			pointsEarned: 0,
			totalPoints: 0,
		},
		{
			id: 7308905,
			collectionId: 673,
			numericId: 7308905,
			status: "COMPLETE",
			startTime: "2026-02-26 15:09:12.305+00",
			sessionType: "FORMATIVE",
			sessionSubType: null,
			distribution: {
				high: 0,
				low: 5,
				medium: 0,
				none: 0,
			},
			numItems: 5,
			numCorrect: 0,
			numIncorrect: 5,
			numSkipped: 0,
			timeTaken: 33,
			pointsEarned: 0,
			totalPoints: 0,
		},
	],
};
